/** Keeps renderHeavy across virtua unmount/remount within a session. */
const MAX_REMEMBERED = 500
const heavyEventIds = new Set<number>()
const insertionOrder: number[] = []

export const wasChatEventHeavyRendered = (eventId: number | undefined): boolean => {
  if (eventId == null) return false
  return heavyEventIds.has(eventId)
}

export const markChatEventHeavyRendered = (eventId: number | undefined): void => {
  if (eventId == null || heavyEventIds.has(eventId)) return
  heavyEventIds.add(eventId)
  insertionOrder.push(eventId)
  while (insertionOrder.length > MAX_REMEMBERED) {
    const oldest = insertionOrder.shift()
    if (oldest != null) heavyEventIds.delete(oldest)
  }
}

/** Clears heavy-render memory (tests / session teardown). */
export const clearChatEventHeavyRenderMemory = (): void => {
  heavyEventIds.clear()
  insertionOrder.length = 0
}
